import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["token", "tenant", "lang", "isDev"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import axios from 'axios';
import { getToken } from './getToken';
export async function getUrl(baseUrl, url, options) {
  var token = options.token,
    tenant = options.tenant,
    lang = options.lang,
    isDev = options.isDev,
    config = _objectWithoutProperties(options, _excluded);
  var accessToken = await getToken({
    token: token
  });
  var headers = _objectSpread(_objectSpread({}, config.headers), {}, {
    'x-tenant-context': tenant,
    'Accept-Language': lang
  });
  if (accessToken) {
    headers.Authorization = accessToken.toString();
  }
  var requestUrl = isDev ? "/mockups".concat(url, ".json") : "".concat(baseUrl).concat(url);
  var _await$axios$get = await axios.get(requestUrl, _objectSpread(_objectSpread({}, config), {}, {
      headers: headers
    })),
    data = _await$axios$get.data;
  return data;
}